import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, renderComponent, branch, lifecycle } from 'recompose';

import { fetchUsers } from '../redux/thunk/users';
import Spinner from '../components/ui-helpers/spinner';
import { Routes } from './routes';


export const AppRoutes = compose(
  connect(
    ({ initialLoad }) => ({ initialLoad }),
    { fetchUsers },
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchUsers();
    },
  }),
  branch(R.prop('initialLoad'), renderComponent(Spinner)),
)(Routes);




// WEBPACK FOOTER //
// ./src/routes/route-container.js